import React from 'react';
import { Form, Select } from 'antd';
import _ from 'lodash';
import InputRequired from './InputRequired';

const FormItem = Form.Item;
const { Option } = Select;

// Input type maybe text or password
export default (props) => {
    const {
        getFieldDecorator,
        fieldName,
        list,
        label,
        placeholder,
        disable,
        mode,
        defaultValue,
        loading,
        required,
    } = props;
    let labelConvert = required ? <InputRequired name={label}/> : label;
    return(
        <FormItem
            label={labelConvert}
            >
            {getFieldDecorator(fieldName, {
                initialValue: defaultValue,
                rules: [
                    { required: required, message: `Vui lòng chọn ${label}` },
                ],
            })(
                <Select
                    showSearch
                    style={{ width: '100%' }}
                    placeholder={ placeholder }
                    optionFilterProp="children"
                    disabled={disable}
                    mode={mode}
                    loading={loading}
                >
                    { _.map(list, (item, index) => (
                        <Option value={item.value} key={index}>{_.truncate(item.name, { 'length': 60, 'separator': '...' })}</Option>
                    )) }
                </Select>
            )}
        </FormItem>
    )
}